import { render, staticRenderFns } from "./Template18.vue?vue&type=template&id=499fa214&scoped=true&"
import script from "./Template18.vue?vue&type=script&lang=js&"
export * from "./Template18.vue?vue&type=script&lang=js&"
import style0 from "./Template18.vue?vue&type=style&index=0&id=499fa214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499fa214",
  null
  
)

export default component.exports